// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgDocumentIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M11.172 2a2 2 0 0 1 1.414.586l5.828 5.828A2 2 0 0 1 19 9.828V20a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zM8 16a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2zm0-4a1 1 0 1 0 0 2h3.5a1 1 0 1 0 0-2z"
      clipRule="evenodd"
    />
  </g>
);
export default SvgDocumentIcon;
SvgDocumentIcon.displayName = 'SvgDocumentIcon';
